var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5131 10.8433L13.9834 8.1235C14.1009 7.44418 13.5785 6.82284 12.8898 6.82284H9.43579C9.09345 6.82284 8.83277 6.51556 8.88818 6.17736L9.32996 3.48099C9.40173 3.04294 9.38123 2.59471 9.26978 2.16506C9.17745 1.80913 8.90285 1.52334 8.5417 1.40732L8.44506 1.37628C8.2268 1.30616 7.98857 1.32248 7.78279 1.42164C7.55629 1.53078 7.39059 1.72986 7.32917 1.96663L7.01203 3.1892C6.91112 3.5782 6.76414 3.95367 6.57463 4.30845C6.29773 4.82682 5.8696 5.24168 5.42458 5.62517L4.46542 6.4517C4.19498 6.68474 4.05296 7.03375 4.08373 7.38964L4.62517 13.6514C4.67484 14.2258 5.15504 14.6667 5.73089 14.6667H8.82997C11.1508 14.6667 13.1315 13.0496 13.5131 10.8433Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.97844 6.32335C2.24595 6.3118 2.47507 6.51305 2.49814 6.77981L3.14587 14.2708C3.18748 14.752 2.80846 15.1667 2.32447 15.1667C1.86859 15.1667 1.5 14.7969 1.5 14.3419V6.82288C1.5 6.55513 1.71093 6.33489 1.97844 6.32335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.de76bcc0e047745a95e3eeb1862bdccf.svg";
export { ForwardRef as ReactComponent };